import { useUserData } from '../../../../hooks'
import { CompanyLogo } from '../../../Company'
import Text from '../../../Text'

import * as styles from './Header.module.css'

function Header() {
  const user = useUserData()

  return (
    <div className={styles.header}>
      <CompanyLogo className={styles.logo} />
      <Text isSecondary unread className={styles.text}>
        {user.fullname} &lt;{user.email}&gt;
      </Text>
    </div>
  )
}

export default Header
